import { SourceType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Navigate,
  useParams,
} from "@tanstack/react-router"

import { OnboardingPageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"
import { DataConsentContent } from "src/pages/Account/DataSource/DataConsent/DataConsentContent"

function isSourceTypeValid(value: string): value is SourceType {
  return Object.values(SourceType).includes(value as SourceType)
}

export function DataConsent() {
  const polyglot = usePolyglot()
  const sourceType = useParams({
    from: "/private/onboarding/data_source/data_consent/$sourceType",
    select: (s) => s.sourceType,
  })

  if (!isSourceTypeValid(sourceType)) {
    return (
      <Navigate
        to={"/onboarding/data_source"}
        params={{}}
        search={{}}
        replace
      />
    )
  }

  return (
    <OnboardingPageTemplate
      title={polyglot.t("components.page_header.pages.update_your_account")}
      backRoutePath="/onboarding/data_source"
    >
      <DataConsentContent
        sourceType={sourceType}
        isOnboarding
      />
    </OnboardingPageTemplate>
  )
}
